import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    defaultNewFixedAssetPercTable,
    setNewFixedAsset
} from "../../../../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";
import {Col, Row} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import moment from "moment";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import AccountingBox from "../../../primer/AccountingBox";
import {fetchFixedAssetsSettings} from "../../../../_apis/api";
import {setSaveNewFixedAsset} from "../../../../_reducers/activitySlice";
import EditableTable from "../../../primer/Editable-Table";
import {
    getDocumentLabel,
    isEmpty,
    startingPeriodOptions
} from "../../../../_helpers/commonFunctions";
import {percentageTableFormatter} from "./constants";
import FixedAssetBuysCorrelation from "./components/fixed-asset-buys-correlation";
import BetterCheckBox from "../../../common/BetterCheckBox";
import FixedAssetSalesCorrelation from "./components/fixed-asset-sales-correlation";
import useInstallationOptions from "../../../../hooks/useInstallationOptions";
import TextArea from "../../../common/TextArea";
import {useTranslation} from "../../../../hooks/useTranslation";

const NewFixedAsset = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const saveNewFixedAsset = useSelector((state) => state.ACTIVITY.saveNewFixedAsset);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const fixedAssetsSettings = useSelector((state) => state.FIXED_ASSETS.fixedAssetsSettings);
    const newFixedAsset = useSelector((state) => state.FIXED_ASSETS.newFixedAsset);

    const installationOptions = useInstallationOptions(false);
    const [incrKey2, setIncrKey2] = useState(0);

    useEffect(() => {
        dispatch(fetchFixedAssetsSettings(company.id));
    }, []);

    useEffect(() => {
        setIncrKey2(incrKey2 + 1);
    }, [newFixedAsset?.mydata]);

    const fixedAssetsCategoryOptions = fixedAssetsSettings.categories.map((o) => {
        return {
            value: o._id,
            label: o.name,
            startingPeriod: o.startingPeriod,
        }
    })

    const myDataColumns = [
        {
            name: t('ProductsNewGeneral.table.rowType'),
            field: "rowType",
            width: "15%",
            editable: true,
            inputType: {
                type: 'select',
                options: [{
                    value: "expense",
                    label: "Έξοδα"
                }]
            }
        },
        {
            name: t('ProductsNewGeneral.table.invoiceType'),
            field: "invoiceType",
            editable: true,
            width: "35%",
            inputType: {
                type: 'select',
                options: [],
            }
        },
        {
            name: t('ProductsNewGeneral.table.category'),
            field: "category",
            editable: true,
            width: "25%",
            inputType: {
                type: 'select',
                options: [],
            }
        },
        {
            name: t('ProductsNewGeneral.table.type'),
            field: 'type',
            editable: true,
            width: "25%",
            inputType: {
                type: 'select',
                options: [],
            }
        },
        /*
        {
            name: t('ProductsNewGeneral.table.vatExpenseType'),
            field: 'vatExpenseType',
            editable: true,
            width: "20%",
            inputType: {
                type: 'select',
                options: getVatExpenseClassificationType(),
            }
        }
         */
    ];

    const percentageTableColumns = [
        {
            name: "Ετήσιο % απόσβεσης",
            field: "percentage",
            editable: true,
            required: true,
            inputType: {
                type: 'accounting',
            }
        },
        {
            name: "Ημερομηνία από",
            field: "dateFrom",
            editable: true,
            required: true,
            inputType: {
                type: 'datebox',
                allowOtherYears: "true",
            }
        },
        {
            name: "Ημερομηνία έως",
            field: "dateTo",
            editable: true,
            required: true,
            inputType: {
                type: 'datebox',
                allowOtherYears: "true",
            }
        },
    ]

    const handleOnChange = (e, type, name) => {
        if (!saveNewFixedAsset) dispatch(setSaveNewFixedAsset(true));

        const prepChange = {};
        if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).hour(10);
            } else {
                prepChange[name] = "";
            }
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "acb") {
            prepChange[name] = e.target.value;
        } else if (type === "cb") {
            prepChange[name] = e.target.checked;
        }
        if (name === "category") {
            prepChange.categoryName = e.label;
            const matchingCategory = fixedAssetsSettings.categories.find((el) => el._id === e.value);
            if (matchingCategory) {
                const asteriskCount = (String(matchingCategory.maskCode).match(/\*/g) || []).length;
                const num = String(matchingCategory.maskCodeCounter || 1).padStart(asteriskCount, "0");
                prepChange.systemCode = String(matchingCategory.maskCode).replace(/\*+/g, num);
                prepChange.startingPeriod = matchingCategory.startingPeriod;
                prepChange.mydata = matchingCategory?.mydata || [];
                //assets accounting
                if (matchingCategory.accounting) prepChange.accounting = matchingCategory.accounting;
                if (matchingCategory.bypassAccounting) prepChange.bypassAccounting = matchingCategory.bypassAccounting;
                if (matchingCategory.inverseAccounting) prepChange.inverseAccounting = matchingCategory.inverseAccounting;
                if (matchingCategory.bypassInverseAccounting) prepChange.bypassInverseAccounting = matchingCategory.bypassInverseAccounting;
                //sales accounting
                if (matchingCategory.accountingCodeSales) prepChange.accountingCodeSales = matchingCategory.accountingCodeSales;
                if (matchingCategory.netAmountAccountingCodeSales) prepChange.netAmountAccountingCodeSales = matchingCategory.netAmountAccountingCodeSales;
                if (matchingCategory.vatAccountingCodeSales) prepChange.vatAccountingCodeSales = matchingCategory.vatAccountingCodeSales;
                if (matchingCategory.taxAccountCodeSales) prepChange.taxAccountCodeSales = matchingCategory.taxAccountCodeSales;
                //buys accounting
                if (matchingCategory.accountingCodeBuys) prepChange.accountingCodeBuys = matchingCategory.accountingCodeBuys;
                if (matchingCategory.netAmountAccountingCodeBuys) prepChange.netAmountAccountingCodeBuys = matchingCategory.netAmountAccountingCodeBuys;
                if (matchingCategory.vatAccountingCodeBuys) prepChange.vatAccountingCodeBuys = matchingCategory.vatAccountingCodeBuys;
                if (matchingCategory.taxAccountCodeBuys) prepChange.taxAccountCodeBuys = matchingCategory.taxAccountCodeBuys;

                if (matchingCategory.vatIsIncluded) prepChange.vatIsIncluded = matchingCategory.vatIsIncluded;
            }
        }
        let newOne = {...newFixedAsset, ...prepChange};
        if (["category", "acquisitionCost"].includes(name)) {
            newOne = percentageTableFormatter(newOne, fixedAssetsSettings);
        }
        dispatch(setNewFixedAsset(newOne));
    }

    const percentageTableFunctions = {
        insert: (e, data) => {
            if (!isEmpty(data.value) && +data.value > 0) {
                if (!saveNewFixedAsset) dispatch(setSaveNewFixedAsset(true));
                const newOne = {...defaultNewFixedAssetPercTable, [data.field] : data.value};
                const clonePercTable = structuredClone(newFixedAsset.percentageTable);
                clonePercTable.push(newOne);
                dispatch(setNewFixedAsset({...newFixedAsset, percentageTable: clonePercTable}));
            }
        },
        update: (data, id, rowIndex) => {
            if (!saveNewFixedAsset) dispatch(setSaveNewFixedAsset(true));
            const clonePercTable = structuredClone(newFixedAsset.percentageTable);
            clonePercTable[rowIndex] = {...clonePercTable[rowIndex], ...data};
            dispatch(setNewFixedAsset({...newFixedAsset, percentageTable: clonePercTable}));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!saveNewFixedAsset) dispatch(setSaveNewFixedAsset(true));
            const clonePercTable = structuredClone(newFixedAsset.percentageTable);
            clonePercTable.splice(rowIndex, 1);
            dispatch(setNewFixedAsset({...newFixedAsset, percentageTable: clonePercTable}));
        },
    }

    const myDataFunctions = {
        insert: (e, data) => {
            if (!saveNewFixedAsset) dispatch(setSaveNewFixedAsset(true));
            const cloneMD = structuredClone(newFixedAsset.mydata || []);
            const newOne = {
                rowType: "",
                invoiceType: "",
                category: "",
                type: "",
                vatExpenseType: "",
            }
            newOne[data.field] = data.value;
            cloneMD.push(newOne);
            dispatch(setNewFixedAsset({...newFixedAsset, mydata: cloneMD}));
        },
        update: (data, id, rowIndex) => {
            if (!saveNewFixedAsset) dispatch(setSaveNewFixedAsset(true));
            const cloneMD = structuredClone(newFixedAsset.mydata);
            cloneMD[rowIndex] = {...cloneMD[rowIndex], ...data};
            if (data.invoiceType) {
                cloneMD[rowIndex].category = "";
                cloneMD[rowIndex].type = "";
                cloneMD[rowIndex].vatExpenseType = "";
            } else if (data.category) {
                cloneMD[rowIndex].type = "";
                cloneMD[rowIndex].vatExpenseType = "";
            } else if (data.type) {
                cloneMD[rowIndex].vatExpenseType = "";
            }
            dispatch(setNewFixedAsset({...newFixedAsset, mydata: cloneMD}));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!saveNewFixedAsset) dispatch(setSaveNewFixedAsset(true));
            const cloneMD = structuredClone(newFixedAsset.mydata);
            cloneMD.splice(rowIndex, 1);
            dispatch(setNewFixedAsset({...newFixedAsset, mydata: cloneMD}));
        },
    }

    const disabledFields = isEmpty(newFixedAsset.category);

    return (
        <div className={"mb-2 product-form position-relative"}>
            {disabledFields && <div className="overlay_w">Παρακαλώ επιλέξτε κατηγορία παγίου</div>}
            <Row>
                <Col md={3} className="showWithOverlay">
                    <Dropdown
                        name={"category"}
                        label={"Κατηγορία Παγίου"}
                        options={fixedAssetsCategoryOptions}
                        key={newFixedAsset.category}
                        defaultValue={fixedAssetsCategoryOptions.find((el) => el.value === newFixedAsset.category)}
                        onChange={(e) => handleOnChange(e, "dd", "category")}
                    />
                </Col>
                {newFixedAsset.category && (
                    <React.Fragment>
                        <Col md={3}>
                            <Dropdown
                                name={"startingPeriod"}
                                label={"Περίοδος έναρξης"}
                                options={startingPeriodOptions}
                                key={newFixedAsset.startingPeriod}
                                defaultValue={startingPeriodOptions.find((per) => per.value === newFixedAsset.startingPeriod)}
                                disabled={true}
                            />
                        </Col>
                        <Col md={3}>
                            <div style={{marginTop: "33px"}}>
                                <BetterCheckBox
                                    name={"vatIsIncluded"}
                                    text={"Ο Φ.Π.Α. αποσβένεται"}
                                    checked={String(newFixedAsset.vatIsIncluded) === "true"}
                                    onChange={(e) => handleOnChange(e, "cb", "vatIsIncluded")}
                                />
                            </div>
                        </Col>
                    </React.Fragment>
                )}
            </Row>
            <Row>
                <Col md={6}>
                    <FixedAssetBuysCorrelation
                        fixedAsset={newFixedAsset}
                        hookCallback={(object, rowNumber) => {
                            dispatch(setNewFixedAsset({
                                ...newFixedAsset,
                                quantity: object.quantity || 1,
                                correlatedBuy: object._id,
                                correlatedBuyLabel: getDocumentLabel(object),
                                correlatedBuyRowNumber: String(rowNumber),
                                acquisitionCost: +Number(
                                    (newFixedAsset.vatIsIncluded === true ?
                                        object.products.find((el) => String(el.no) === String(rowNumber))?.totalValue
                                        :
                                        object.products.find((el) => String(el.no) === String(rowNumber))?.netValue) || 0,
                                ).toFixed(2),
                            }))
                        }}
                        unHookCallback={() => {
                            dispatch(setNewFixedAsset({
                                ...newFixedAsset,
                                correlatedBuy: "",
                                correlatedBuyLabel: "",
                                correlatedBuyRowNumber: "",
                            }))
                        }}
                    />
                </Col>
                <Col md={6}>
                    <Col md={6}>
                        <FixedAssetSalesCorrelation
                            fixedAsset={newFixedAsset}
                            unHookCallback={() => {
                                dispatch(setNewFixedAsset({
                                    ...newFixedAsset,
                                    correlatedSale: "",
                                    correlatedSaleLabel: "",
                                    correlatedSaleRowNumber: "",
                                }))
                            }}
                        />
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    <Input
                        name={"name"}
                        label={"Όνομα παγίου"}
                        required={true}
                        value={newFixedAsset.name}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "name")}
                    />
                </Col>
                <Col md={1}>
                    <Input
                        name={"quantity"}
                        label={"Ποσότητα"}
                        value={newFixedAsset.quantity}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "quantity")}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name={"systemCode"}
                        label={"Κωδικός Συστήματος"}
                        value={newFixedAsset.systemCode}
                        autoComplete={"off"}
                        disabled={true}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"manualCode"}
                        label={"Χειροκίνητος Κωδικός"}
                        value={newFixedAsset.manualCode}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "manualCode")}
                    />
                </Col>
                <Col md={3}>
                    <Dropdown
                        name={"installation"}
                        label={"Εγκατάσταση"}
                        options={installationOptions}
                        defaultValue={installationOptions.find((el) => el.value === newFixedAsset.installation)}
                        key={newFixedAsset.installation}
                        onChange={(e) => handleOnChange(e, "dd", "installation")}
                    />
                </Col>
            </Row>
            <Row className={"mt-2"}>
                <Col md={3}>
                    <DateBox
                        name={"dateFrom"}
                        label={"Ημερομηνία έναρξης"}
                        allowOtherYears={true}
                        selected={newFixedAsset.dateFrom || null}
                        onChange={(e) => handleOnChange(e, "datebox", "dateFrom")}
                    />
                </Col>
                <Col md={3}>
                    <div className={"mb-1"}>Αξία κτήσης</div>
                    <AccountingBox
                        name={"acquisitionCost"}
                        key={newFixedAsset.acquisitionCost}
                        defaultValue={newFixedAsset.acquisitionCost}
                        disabled={!isEmpty(newFixedAsset.correlatedBuy)}
                        onBlur={(e) => handleOnChange(e, "acb", "acquisitionCost")}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <div className={"text-muted mb-1"}><i>Πίνακας Αποσβέσεων</i></div>
                    <EditableTable
                        tableName={"Fixed Assets Category Percentage Table"}
                        key={Math.random()}
                        columns={percentageTableColumns}
                        onUpdate={percentageTableFunctions}
                        data={newFixedAsset?.percentageTable ? newFixedAsset.percentageTable : []}
                        allowInsertRow={true}
                        allowActions={true}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="text-muted mb-2"><i>My Data</i></div>
                    <EditableTable
                        tableName="New Fixed Asset My Data"
                        key={"NFAMD" + incrKey2}
                        allowActions={true}
                        onUpdate={myDataFunctions}
                        allowInsertRow={true}
                        columns={myDataColumns}
                        enableNewRowCheckbox={true}
                        data={newFixedAsset.mydata || []}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <TextArea
                        name={"notes"}
                        label={"Παρατηρήσεις / Σημειώσεις"}
                        rows={3}
                        value={newFixedAsset.notes}
                        onChange={(e) => handleOnChange(e, "input", "notes")}
                    />
                </Col>
            </Row>
        </div>
    )
}

export const NewFixedAssetAccounting = () => {
    const dispatch = useDispatch();
    const saveNewFixedAsset = useSelector((state) => state.ACTIVITY.saveNewFixedAsset);
    const newFixedAsset = useSelector((state) => state.FIXED_ASSETS.newFixedAsset);

    const handleOnChange = (e, type, name) => {
        if (!saveNewFixedAsset) dispatch(setSaveNewFixedAsset(true));
        const prepChange = {};
        if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).hour(10);
            } else {
                prepChange[name] = "";
            }
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "acb") {
            prepChange[name] = e.target.value;
        } else if (type === "cb") {
            prepChange[name] = e.target.checked;
        }
        let newOne = {...newFixedAsset, ...prepChange};
        dispatch(setNewFixedAsset(newOne));
    }

    return (
        <React.Fragment>
            <p className="text-muted"><i>Ρυθμίσεις Λογιστικής</i></p>
            <div className="text-muted mb-2"><i>Ρυθμίσεις Λογιστικής για Αποσβέσεις - Κινήσεις Παγίων</i></div>
            <Row className={"mb-2"}>
                <Col md={3}>
                    <Input
                        name={"accounting"}
                        label={"Πρόθεμα Λογιστικής Γέφυρας"}
                        value={newFixedAsset?.accounting}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "accounting")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"bypassAccounting"}
                        label={"Κωδικός Παράκαμψης Λογιστικής Γέφυρας"}
                        value={newFixedAsset?.bypassAccounting}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "bypassAccounting")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"inverseAccounting"}
                        label={"Πρόθεμα Αντισυμβαλλόμενου Κωδικού Λογιστικής"}
                        value={newFixedAsset?.inverseAccounting}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "inverseAccounting")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"bypassInverseAccounting"}
                        label={"Αντισυμβαλλόμενος Κωδικός Παράκαμψης Λογιστικής Γέφυρας"}
                        value={newFixedAsset?.bypassInverseAccounting}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "bypassInverseAccounting")}
                    />
                </Col>
            </Row>

            <div className="text-muted mb-2"><i>Ρυθμίσεις Λογιστικής για Αγορές Παγίων</i></div>
            <Row className={"mb-2"}>
                <Col md={3}>
                    <Input
                        name={"accountingCodeBuys"}
                        label={"Πρόθεμα Κωδικού Λογαριασμού"}
                        value={newFixedAsset?.accountingCodeBuys}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "accountingCodeBuys")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"netAmountAccountingCodeBuys"}
                        label={"Κωδικός Λογαριασμού Παράκαμψης Καθαρής Αξίας"}
                        value={newFixedAsset?.netAmountAccountingCodeBuys}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "netAmountAccountingCodeBuys")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"vatAccountingCodeBuys"}
                        label={"Κωδικός Λογαριασμού Παράκαμψης ΦΠΑ"}
                        value={newFixedAsset?.vatAccountingCodeBuys}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "vatAccountingCodeBuys")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"taxAccountCodeBuys"}
                        label={"Κωδικός λογαριασμού Παράκαμψης Φόρου"}
                        value={newFixedAsset?.taxAccountCodeBuys}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "taxAccountCodeBuys")}
                    />
                </Col>
            </Row>

            <div className="text-muted mb-2"><i>Ρυθμίσεις Λογιστικής για Πωλήσεις Παγίων</i></div>
            <Row className={"mb-2"}>
                <Col md={3}>
                    <Input
                        name={"accountingCodeSales"}
                        label={"Πρόθεμα Κωδικού Λογαριασμού"}
                        value={newFixedAsset?.accountingCodeSales}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "accountingCodeSales")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"netAmountAccountingCodeSales"}
                        label={"Κωδικός Λογαριασμού Παράκαμψης Καθαρής Αξίας"}
                        value={newFixedAsset?.netAmountAccountingCodeSales}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "netAmountAccountingCodeSales")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"vatAccountingCodeSales"}
                        label={"Κωδικός Λογαριασμού Παράκαμψης ΦΠΑ"}
                        value={newFixedAsset?.vatAccountingCodeSales}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "vatAccountingCodeSales")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"taxAccountCodeSales"}
                        label={"Κωδικός λογαριασμού Παράκαμψης Φόρου"}
                        value={newFixedAsset?.taxAccountCodeSales}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "taxAccountCodeSales")}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default NewFixedAsset;
